import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "for-whom container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "for-whom__title title" }, "Для кого", -1)
const _hoisted_3 = { class: "for-whom__list" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "example__title" }
const _hoisted_6 = ["id"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "for-whom__item example"
        }, [
          _createElementVNode("img", {
            src: _ctx.IMAGE_BASE_URL + item.imgUrl,
            alt: "Иллюстрация примера"
          }, null, 8, _hoisted_4),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(item.title), 1),
          _createElementVNode("p", {
            class: "example__desc",
            id: `for-whom-desc-${item.id}`
          }, null, 8, _hoisted_6)
        ]))
      }), 128))
    ]),
    _createElementVNode("img", {
      class: "for-whom__lines",
      src: _ctx.IMAGE_BASE_URL + 'for-whom-lines.png',
      alt: ""
    }, null, 8, _hoisted_7)
  ]))
}